<template>
	<transition name="message-list">
		<transition-group name="message-model":duration="1000" class="m-message-list" v-if="list.length" tag="div">
			<div class="m-message-model" v-for="(item, index) in list" :key="item.index" :class="item.typeClass">
				<img :src="item.typeIcon" alt="" class="type_icon">
				<div class="msg_text">{{item.message }} </div>
				
			</div>
		</transition-group>
	</transition>
	
		
</template>

<script>
	
	export default {
		name: 'mMessage',
		data: () => ({
			message: null,
			type: null,
			list: []
		}),
		computed: {
		},
		methods: {
			show(message, type, time) {
				let typeText = '',typeIcon
				switch(type) {
					case 'success':
						typeText = '成功: '
						typeIcon = require(`@/assets/message/success.png`)
					break;
					case 'error':
						typeText = '失败: '
						typeIcon = require(`@/assets/message/error.png`)
					break;
					case 'warn':
						typeText = '警告: '
						typeIcon = require(`@/assets/message/warn.png`)
					break;
					case 'default':
						typeIcon = require(`@/assets/message/default.png`)
					break;
				}
				let messageItem = {typeIcon, type, message, typeText, typeClass: `m-${type}-message`, index: new Date().getTime() + this.list.length}
				this.list.push(messageItem)
				let timer
				timer = setTimeout(() => {
					this.list.splice(this.list.find(item => item === messageItem), 1 )
				}, time || 3000)
			}
		}
	}
</script>

<style scoped lang="less">
	.m-message-list{
		position: fixed;
		z-index: 9999;
		top: 10%;
		left: 50%;
		transform: translateX(-50%);
		min-width: 300px;
		max-width: 600px;
		line-height: 32px;
		font-size: 16px;
	}
	.m-message-model{
		padding: 16px 24px;
		min-width: 300px;
		max-width: 600px;
		padding-left: 68px;
		color: #fff;
		margin-bottom: 15px;
		transition: all 1s;
		position: relative;
		&.m-success-message{
			background: linear-gradient(90deg, #33CD7A 13.79%, #33CDBB 87.47%);
		}
		&.m-warn-message{
			background: linear-gradient(90deg, #FBB21a 13.79%, #FBB231 87.47%);
		}
		&.m-error-message{
			background: linear-gradient(90deg, #F04C01 13.79%, #F04C27 87.47%);
		}
		&.m-default-message{
			background: linear-gradient(90deg, #2FB1dd 13.79%, #2FB1FF 87.47%);
		}
		.type_icon{
			width: 32px;
			height: 32px;
			display: block;
			position: absolute;
			top: 16px;
			left: 24px;
		}
		.msg_text{
			word-wrap: normal;
			word-break: break-all;
			white-space: pre-wrap;
		}
		
	}
	// @keyframes message-model {
	// 	0% {
	// 		// transform: rotate3d(90deg,90deg,0)
	// 		// transform: rotateX(85deg)
	// 		opacity: 0;
	// 		zoom: 1;
	// 	}
	// 	50% {
	// 		// transform: rotate3d(90deg, 0, 0);
	// 		opacity: .5;
	// 		zoom: 1.1;
	// 	}
	// 	100%{
	// 		// transform: rotateX(0deg)
	// 		// transform: rotate3d(0,0,0);
	// 		opacity: 1;
	// 		zoom: 1;
	// 	}
	// }
	.message-list-enter-active,.message-list-leave-active{
		transition: opacity 1s;
	}
	.message-list-enter,.message-list-leave-to{
		opacity: 0;
	}
	.message-model-enter-active,.message-model-leave-active{
		position: absolute;
	}
	.message-model-enter,.message-model-leave-to{
		opacity: 0;
	}
	.message-model-move {
	  transition: transform 1s;
	}
	
</style>